import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import idx from 'idx';
import { ADD_FORM_NAME, EDIT_REVISIONS_FORM_NAME } from 'presentations/constants';
import ImageNameTile from 'focus_groups/components/image_name_tile';

const mapStateToProps = (state, { item }) => {
  /* get list of selected revisions based on active form */
  const selector = formValueSelector(
    state.project.presentations.showingAddModal? ADD_FORM_NAME : EDIT_REVISIONS_FORM_NAME
  );
  const selected = selector(state, 'selected_revisions') || [];

  return {
    selected: selected.includes(item.revisions[0].id)
  };
}

export default connect(mapStateToProps)(ImageNameTile);



// WEBPACK FOOTER //
// ./presentations/containers/image_name_tile.js